import { createSvgIcon } from '@automata/mui-theme';
export const ReservoirIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.2433 18.701C58.7074 18.433 59.2792 18.433 59.7433 18.701L81.9135 31.501C82.3776 31.7689 82.6635 32.2641 82.6635 32.8V52C82.6635 52.5359 82.3776 53.0311 81.9135 53.299L36.8802 79.299C36.4161 79.567 35.8443 79.567 35.3802 79.299C34.9161 79.0311 34.6302 78.5359 34.6302 78V59.666L13.21 47.299C12.7459 47.0311 12.46 46.5359 12.46 46C12.46 45.4641 12.7459 44.9689 13.21 44.701L58.2433 18.701ZM37.6302 59.666V75.4019L79.6635 51.134V35.3981L37.6302 59.666ZM78.1635 32.8L36.1302 57.068L16.96 46L58.9933 21.7321L78.1635 32.8Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.46 64.3338V45.9998L12.46 46L12.46 65.1998C12.46 65.7357 12.7459 66.2309 13.21 66.4988L35.3802 79.299C35.8443 79.567 36.4161 79.567 36.8802 79.299L81.9135 53.299L80.4135 50.7007L36.1302 76.2677L15.46 64.3338Z"
    />
    <path d="M21.3125 46L59.0121 24.2342L73.8845 32.8208L36.185 54.5866L21.3125 46Z" />
  </svg>,
  'ReservoirIcon'
);
